import React, { useEffect } from 'react';
import _get from 'lodash/get';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import queryString from 'query-string';

import { isLoading, isNormal, useStatus, useData } from 'resift';
import makeStyles from '@material-ui/core/styles/makeStyles';
import makeGetUsers from 'fetches/search/makeGetUsers';

import CircularProgress from '@material-ui/core/CircularProgress';
import UsersTab from './UsersTab';

function Container() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { search } = useLocation();
  const query = queryString.parse(search);
  const getUsers = makeGetUsers('Role Members');
  const status = useStatus(getUsers);
  const data = useData(getUsers);

  useEffect(() => {
    dispatch(
      getUsers({
        ...query,
        expandRoles: true,
        email_exists: true,
      }),
    );
  }, [search]);

  if (isLoading(status)) {
    return <CircularProgress color="secondary" className={classes.loading} />;
  }

  if (!isNormal(status)) {
    return <div>Something went wrong.</div>;
  }

  return (
    <UsersTab
      usersData={_get(data.results[0], 'items', [])}
      pagination={_get(data, 'pagination', {})}
    />
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  loading: {
    display: 'flex',
    margin: 'auto',
  },
}));

export default Container;
